var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type",class:{ 'restricted': _vm.isRestricted()}},[(_vm.status === 'expired')?[_vm._v(" Expired ")]:_vm._e(),(_vm.status === 'expires')?[_vm._v(" Billing issues ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }